const getUrlParams = (key: string) => {
  const params = new URLSearchParams(window.location.search);
  const result = params.get(key);
  return result || undefined;
};

const getUrlParameter = (sParam: string): string | null => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get(sParam);
};

const getUrlParameterJson = (): string => {
  var search = window.location.search.substring(1);
  if (search !== '') {
    var urlParams = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
      return key === '' ? value : decodeURIComponent(value);
    });
    if (!getUrlParams('shop')) {
      urlParams.shop = urlParams.store;
    }
    delete urlParams.store;
    return JSON.stringify(urlParams);
  }
  return '';
};

export const config = {
  instance: getUrlParams('instance'),
  instanceId: getUrlParams('instanceId'),
  shop: getUrlParams('shop'),
  urlParams: getUrlParameterJson(),
  source: getUrlParameter('source'),
  token: getUrlParameter('token'),
  site: decodeURIComponent(getUrlParams('siteUrl') || '').match(/\/\/www\.([^.]+)\./),
};
